import React, { useState } from "react";
import Header from "app/modules/Dashboard/Header";
import Leaders from "app/modules/Dashboard/Leaderboard/Corporate/Leaders";

import "./styles.scss";

const Leaderboard = () => {
  const [country, setCountry] = useState("au");
  const [state, setState] = useState(null);

  return (
    <div className="leaders-page">
      <Header withCustomDates country={country} setCountry={setCountry} state={state} setState={setState} />
      <div className="leaderboard">
        <div className="leaderboard-corporate">
          <Leaders leadersPage withSearch country={country} state={state} />
        </div>
      </div>
    </div>
  );
};

export default Leaderboard;
